module.exports = __webpack_public_path__ + "img/confirmation_green.c3fe60b4.svg";